import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetMainNavResponse } from './types/get-main-nav.type';

const emptyMainNavResponse = (
	status = 200
): AxiosResponse<GetMainNavResponse> =>
	({
		data: [],
		status,
		statusText: 'OK',
		headers: {},
		config: {},
		request: undefined,
	}) as unknown as AxiosResponse<GetMainNavResponse>;

export const getMainNav = async (
	locale = 'en'
): Promise<AxiosResponse<GetMainNavResponse>> => {
	try {
		const response = await api.get(`/nav/${locale}/primary`);

		// Stage can return HTTP 204 with an empty body. Axios then sets
		// `data` to `""`, which is truthy for optional chaining but is not
		// an array — so callers that call `.find` would throw.
		if (!Array.isArray(response.data)) {
			return {
				...response,
				data: [],
			};
		}

		return response;
	} catch (error) {
		console.error(
			`[getMainNav] failed to load main nav for locale=${locale}:`,
			error
		);

		return emptyMainNavResponse();
	}
};
